import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const simpson_filter_faq_data = [
    {
        question: "What is the Simpson Filter, and how does it work?",
        answer: "The Simpson Filter uses AI to transform your photos into classic yellow cartoon characters inspired by the world of The Simpsons. It applies signature features like bold outlines, flat shading, and expressive eyes, making your picture look like it belongs in Springfield.",
    },
    {
        question:
            "Do I need drawing or editing skills to use the Simpson Filter?",
        answer: "Not at all! Just upload your photo, and the AI instantly turns you into a Simpsons-style cartoon. It’s fully automated, beginner-friendly, and doesn’t require any manual editing.",
    },
    {
        question: "What kinds of photos work best with the Simpson Filter?",
        answer: "Portraits work best — individual, couple, or even group selfies. You can also try it on pets or full-body photos for a more complete Simpsons-style makeover.",
    },
    {
        question: "Are my photos safe and private?",
        answer: "Yes. Your photos are processed securely and automatically deleted after a short period. We never store or share your content.",
    },
];

const simpson_filter_use_cases = [
    {
        title: "Social Media Avatars",
        description:
            "Create fun and unique Simpsons-style profile pictures for Instagram, TikTok, or Discord. Instantly recognizable and full of personality, these avatars help you stand out online.",
        image: "/images/image-filters/simpson-filter-5.webp",
    },
    {
        title: "Family & Friends Cartoon Portraits",
        description:
            "Turn your whole family or friend group into characters straight out of Springfield. Perfect for digital prints, personalized gifts, or fun keepsakes.",

        image: "/images/image-filters/simpson-filter-6.webp",
    },
    {
        title: "Pop Culture Projects",
        description:
            "Design posters, thumbnails, or digital art projects with a Simpsons twist. Ideal for creators, designers, and meme lovers who want to add humor and nostalgia to their visuals.",
        image: "/images/image-filters/simpson-filter-7.webp",
    },
];

const SimpsonFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/simpson-filter-1.webp"}
                title={"Turn Yourself into a Simpsons Character"}
                description={
                    "Ever wondered what you’d look like as a character in Springfield? The Simpson Filter recreates your look with bright yellow tones, flat shading, and the classic cartoon style fans love."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/simpson-filter-2.webp"}
                title={"Cartoonize Your Friends, Family, or Pets"}
                description={
                    "Bring the fun to everyone — from your best friend to your dog. The Simpson Filter captures personalities in the signature cartoon look, adding humor and warmth to your favorite photos."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/simpson-filter-3.webp"}
                title={"Perfect for Profile Pictures and Posts"}
                description={
                    "Make your online presence unforgettable with a Simpsons-style avatar. Whether for social media, messaging apps, or streaming profiles, it’s a fun way to show your playful side."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/simpson-filter-4.webp"}
                title={"Reimagine Your World in Cartoon Style"}
                description={
                    "From portraits to group shots, the AI adds clean outlines, bold colors, and that classic Simpsons vibe. It's nostalgic, hilarious, and endlessly shareable."
                }
            />
            <UseCases
                data={simpson_filter_use_cases}
                title={"Creative and Pretty Simpson Filters for Everyone"}
            />
            <SellFaq data={simpson_filter_faq_data} />
        </PBox>
    );
};

export default SimpsonFilter;
